import { render, staticRenderFns } from "./NewCustomerForm.vue?vue&type=template&id=5038e8c8&scoped=true"
import script from "./NewCustomerForm.vue?vue&type=script&lang=js"
export * from "./NewCustomerForm.vue?vue&type=script&lang=js"
import style0 from "./NewCustomerForm.vue?vue&type=style&index=0&id=5038e8c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5038e8c8",
  null
  
)

export default component.exports